import React from 'react';

const PaymentSuccess = () => {
  return (
    <div className="text-center mt-20">
      <h2 className="text-2xl font-bold text-green-600">🎉 Payment Successful!</h2>
      <p className="mt-4">Thank you for your payment. You may now access your courses.</p>
    </div>
  );
};

export default PaymentSuccess;
